export var PvValuationBlockAgricultureActivityHeadingEnum;
(function (PvValuationBlockAgricultureActivityHeadingEnum) {
    PvValuationBlockAgricultureActivityHeadingEnum["Activity"] = "Activity";
    PvValuationBlockAgricultureActivityHeadingEnum["AdjustmentFactor"] = "Adjustment factor";
    PvValuationBlockAgricultureActivityHeadingEnum["Method"] = "Method";
})(PvValuationBlockAgricultureActivityHeadingEnum || (PvValuationBlockAgricultureActivityHeadingEnum = {}));
export const ValuationBlockAgricultureActivitiesConfigHeadingLookup = new Map([
    [PvValuationBlockAgricultureActivityHeadingEnum.Activity, "activity"],
    [PvValuationBlockAgricultureActivityHeadingEnum.AdjustmentFactor, "adjustmentFactor"],
    [PvValuationBlockAgricultureActivityHeadingEnum.Method, "method"]
]);
